<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <!-- <nav>
        <ul>
          <li>
            
          </li>
        </ul>
      </nav> -->
      <div class="copyright d-flex flex-wrap">
        &copy; The Ecoverse by Net Zero Analytics
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
